export default __webpack_public_path__ + "static/media/amedia.9e508ebf.svg";